import { pipe } from 'overmind';

import type { Context } from '@/overmind';

export const resetArcGisState = pipe((context: Context) => {
  // Has to be reset first, otherwise old token or config can accidentally be used on new tenant
  // context.actions.arcgis.token.resetTokenState();
  context.actions.arcgis.config.resetArcGisConfigState();
  // order of the rest is not important
  context.actions.arcgis.featureGeometries.resetFeatureGeometriesState();
  context.actions.arcgis.featureServer.resetFeatureServerState();
  context.actions.arcgis.featuresInBounds.resetFeaturesInBoundsState();
  context.actions.arcgis.featureTypes.resetFeatureTypesState();
  context.actions.arcgis.mapImage.resetMapImageState();
  context.actions.arcgis.featureSearch.resetFeatureSearchState();
  // context.state.arcgis.auth.send('RESET');
  context.state.auth.send('AUTHENTICATE_ARCGIS');
});

export const authenticateManually = pipe(async (context: Context) => {
  const signedInUser = await context.effects.arcgis.auth.identity.getCredential(
    context.state.arcgis.config.value
  );
  const token = signedInUser?.token;
  context.state.auth.send('AUTHENTICATE_ARCGIS_MANUALLY', token);
});
